import { Col, Row } from 'react-bootstrap';
import { Control, FieldErrors } from 'react-hook-form';

import { Group, Input } from 'apps/shared/scripts/components';

import { FORM_FIELDS } from './constants';
import { FormValues } from './types';

interface Props {
  errors?: FieldErrors<FormValues>;
  control: Control<FormValues>;
}

const NameInputFields = ({ errors, control }: Props) => {
  return (
    <Row>
      <Col>
        <Group
          errors={errors}
          label={FORM_FIELDS.FIRST_NAME.label}
          validate={FORM_FIELDS.FIRST_NAME.name}
        >
          <Input control={control} name={FORM_FIELDS.FIRST_NAME.name} />
        </Group>
      </Col>
      <Col>
        <Group
          errors={errors}
          label={FORM_FIELDS.LAST_NAME.label}
          validate={FORM_FIELDS.LAST_NAME.name}
        >
          <Input control={control} name={FORM_FIELDS.LAST_NAME.name} />
        </Group>
      </Col>
    </Row>
  );
};

NameInputFields.displayName = 'NameInputFields';

export default NameInputFields;
